/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MemberTeam
 */
export interface MemberTeam {
  /**
   *
   * @type {string}
   * @memberof MemberTeam
   */
  teamId: string;
  /**
   *
   * @type {string}
   * @memberof MemberTeam
   */
  name: string;
}

/**
 * Check if a given object implements the MemberTeam interface.
 */
export function instanceOfMemberTeam(value: object): value is MemberTeam {
  if (!("teamId" in value) || value["teamId"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function MemberTeamFromJSON(json: any): MemberTeam {
  return MemberTeamFromJSONTyped(json, false);
}

export function MemberTeamFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MemberTeam {
  if (json == null) {
    return json;
  }
  return {
    teamId: json["teamId"],
    name: json["name"],
  };
}

export function MemberTeamToJSON(json: any): MemberTeam {
  return MemberTeamToJSONTyped(json, false);
}

export function MemberTeamToJSONTyped(
  value?: MemberTeam | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamId: value["teamId"],
    name: value["name"],
  };
}
